(() => {
	angular.module('main').directive('convertToNumber', convertToNumber);

	function convertToNumber() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link(scope, element, attrs, ngModel) {
				ngModel.$parsers.push(val => parseInt(val, 10));
				ngModel.$formatters.push(val => `${val}`);
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Filelds/convertToNumber.js